import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { mockBrokers, mockOffices, mockBrokerUsers } from '../../services/mockData';

const BrokerDetailPage = () => {
  const { id } = useParams();
  const [broker, setBroker] = useState(null);
  const [offices, setOffices] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      const brokerData = mockBrokers.find(b => b.id === parseInt(id));
      const brokerOffices = mockOffices.filter(o => o.brokerId === parseInt(id));
      const brokerUsers = mockBrokerUsers.filter(u => u.id >= 2 && u.id <= 6);
      
      setBroker(brokerData);
      setOffices(brokerOffices);
      setUsers(brokerUsers);
      setLoading(false);
    }, 500);
  }, [id]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!broker) {
    return (
      <div className="empty">
        <div className="empty-icon">
          <i className="ti ti-alert-circle"></i>
        </div>
        <p className="empty-title">Broker not found</p>
        <div className="empty-action">
          <Link to="/lender/brokers" className="btn btn-primary">
            Back to Brokers
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-header d-print-none">
      <div className="row g-2 align-items-center mb-3">
        <div className="col">
          <div className="page-pretitle">
            <Link to="/lender/brokers">Brokers</Link>
          </div>
          <h2 className="page-title">{broker.name}</h2>
        </div>
        <div className="col-auto ms-auto">
          <span className={`badge ${broker.status === 'Active' ? 'bg-green' : 'bg-red'}`}>
            {broker.status}
          </span>
        </div>
      </div>

      <div className="row row-cards">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Broker Profile</h3>
            </div>
            <div className="card-body">
              <div className="datagrid">
                <div className="datagrid-item">
                  <div className="datagrid-title">Main Office NMLS</div>
                  <div className="datagrid-content">{broker.mainOfficeNmls}</div>
                </div>
                <div className="datagrid-item">
                  <div className="datagrid-title">Email</div>
                  <div className="datagrid-content">{broker.email}</div>
                </div>
                <div className="datagrid-item">
                  <div className="datagrid-title">Phone</div>
                  <div className="datagrid-content">{broker.phone}</div>
                </div>
                <div className="datagrid-item">
                  <div className="datagrid-title">Address</div>
                  <div className="datagrid-content">{broker.address}</div>
                </div>
                <div className="datagrid-item">
                  <div className="datagrid-title">Created Date</div>
                  <div className="datagrid-content">{new Date(broker.createdDate).toLocaleDateString()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Offices ({offices.length})</h3>
            </div>
            <div className="list-group list-group-flush">
              {offices.map((office) => (
                <div key={office.id} className="list-group-item">
                  <div className="row align-items-center">
                    <div className="col">
                      <div className="fw-bold">{office.name}</div>
                      <div className="text-secondary small">NMLS: {office.nmls}</div>
                    </div>
                    <div className="col-auto">
                      {office.isMain && (
                        <span className="badge bg-blue-lt">Main</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Users ({users.length})</h3>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-vcenter">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>NMLS</th>
                      <th>Office</th>
                      <th>Role</th>
                      <th>Login Type</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr key={user.id}>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td><span className="badge bg-blue-lt">{user.nmls}</span></td>
                        <td>{user.officeName}</td>
                        <td>{user.role === 'BrokerAdmin' ? 'Admin' : 'Loan Officer'}</td>
                        <td>
                          <span className={`badge ${
                            user.loginType === 'Both' ? 'bg-purple-lt' :
                            user.loginType === 'Federated' ? 'bg-cyan-lt' : 'bg-gray-lt'
                          }`}>
                            {user.loginType}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${user.status === 'Active' ? 'bg-green-lt' : 'bg-red-lt'}`}>
                            {user.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrokerDetailPage;
